import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSummaBillingAvtal,setofUpdatedashboardAvtal,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {Grid} from '@material-ui/core'
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardAvtal, Flags} = accountsData
    const { SummaBillingAvtal,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,SummaBillingAvtal,DashboardAnpassadFilterOption,updatedashboardAvtal, Flags
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getSummaBillingAvtal: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getSummaBillingAvtal(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
        setofUpdatedashboardAvtal: () => dispatch(setofUpdatedashboardAvtal()),
        dispatch
    }
}


class Abonnemang extends Component {
    state={
        SummaBillingAvtal:0,
        DashboardAnpassadFilterOption:[],
        done: true
    }
    intervalID = null
    componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getSBA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            abonnamangeSetting:this.props.abonnamangeSetting,
            userid:userid
          }))
        })
        .then(res => {
             if(res.data.success){
                                        let endata = decrypt(res.data.encryptedData,res.data.iv)
                                        let ndate = JSON.parse(endata)
                                        this.setState({ 
                                            SummaBillingAvtal:ndate.results.SummaBillingAvtal
                                         });
                                            this.initiateInterval() 
                                            //this.setState({done: true})  
                                    }
           
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                 //   this.setState({done: false})
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                axios.get(`kontos/DashBoard/getSBA`,
                { params:encrypt(JSON.stringify({
                    Afid:Afid,
                    FilterOption:[],
                    intervaltype:this.props.intervaltype,
                    abonnamangeSetting:this.props.abonnamangeSetting,
                    userid:userid
                  }))
                })
                .then(res => {
                    if(res.data.success){
                        let endata = decrypt(res.data.encryptedData,res.data.iv)
                        let ndate = JSON.parse(endata)
                        this.setState({ 
                            SummaBillingAvtal:ndate.results.SummaBillingAvtal
                         });
                            this.initiateInterval() 
                            //this.setState({done: true})  
                    } 
                })
            }
            },
            180000
        );
        
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardAvtal) === 1){           
            axios.get(`kontos/DashBoard/getSBA`,
            { params:encrypt(JSON.stringify({
                Afid:Afid,
                FilterOption:[],
                intervaltype:this.props.intervaltype,
                abonnamangeSetting:this.props.abonnamangeSetting,
                userid:userid
              }))
            })
            .then(res => {
                if(res.data.success){
                    let endata = decrypt(res.data.encryptedData,res.data.iv)
                    let ndate = JSON.parse(endata)
                    this.setState({ 
                        SummaBillingAvtal:ndate.results.SummaBillingAvtal
                     });
                        this.initiateInterval() 
                        //this.setState({done: true})  
                } 
            })
            this.props.setofUpdatedashboardAvtal()
          }  
      
    }
    formatNumber=(number)=>{
        let Nubmer = NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', 'auto', 0)
        let suffix = Nubmer.match(/[a-zA-Z]+/g)
        let num = Nubmer.replace(suffix, '').trim()
        return <div>
            <span style={{ fontSize: 40 }}>{num}</span>
            <span style={{ fontSize: '16px', marginLeft: 5 }}>{this.formatNumberT(number)}</span> 
      </div>
   }
		formatNumberT=(number)=>{
        try{
            let Nubmer = NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', 'auto', 0)
            let num = Nubmer.match(/[a-zA-Z]+/g)
            return num
        }
        catch(error){
            return ''
        }
    }	
    render() {
        const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
        return (<>
            {
                this.state.done === false?
                <Skeleton variant="rectangular"  height={'84%'} style={{margin:10,backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                :
            <div className="h-100 d-flex w-100 flex-column justify-content-between px-3 py-2" style={{ color: isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, width: '100%' }}>
              <div className='d-flex align-items-center justify-content-between'>
                <h2 className='mb-0' style={{fontWeight:"300", color: isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><b><IntlMessages id="DashBoard.Contract.invoicing"/></b></h2>
              </div>
                
              <div className="d-flex justify-content-between w-100 align-items-end align-items-baseline">
                <p className="" style={{ fontSize: 40,  lineHeight: 1, fontWeight:"500" }}>
                  {this.formatNumber(this.state.SummaBillingAvtal)}
                </p>
                  <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
              </div>
            </div>
    }</>
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(Abonnemang);